import { OptionValue } from '@/components/Option/types'

export const isOptionValue = (
  value: OptionValue | undefined | null,
): value is OptionValue =>
  typeof value === 'string' || typeof value === 'number'
